export const FETCH_VEHICLES = "FETCH_VEHICLES";
export const FETCH_STATES = "FETCH_STATES";
export const FETCH_DRIVERS = "FETCH_DRIVERS";
export const FETCH_SEGMENT_EVENTS = "FETCH_SEGMENT_EVENTS";
